import { ensureExists } from "@/lib/ensureExists";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { topListQueryOptions } from "@/lib/productPageQuery";
import TopList from "@/pages/TopList";

export const Route = createFileRoute("/best/$slug")({
  beforeLoad: ({ params }) => ensureExists("top_lists", params.slug),
  loader: async ({ params, context }) => {
    const list = await context.queryClient.ensureQueryData(topListQueryOptions(params.slug));
    if (!list) throw notFound();
    return { list };
  },
  head: ({ params, loaderData }) => {
    const canonicalUrl = "https://www.garden-review.co.uk" + `/best/${params.slug}`;
    const list = loaderData?.list;
    if (!list) return {};
    const description = list.meta_description || list.title;
    return {
      meta: [
        { title: `${list.title} | Garden-Review` },
        { name: "description", content: description },
        { property: "og:title", content: list.title },
        { property: "og:description", content: description },
        { property: "og:url", content: canonicalUrl },
        { property: "og:type", content: "article" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: list.title },
        { name: "twitter:description", content: description },
        ...(list.featured_image?.startsWith("https://") ? [
          { property: "og:image", content: list.featured_image },
          { name: "twitter:image", content: list.featured_image },
        ] : []),
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: TopList,
});
